export const SET_SELECTED_MODELER_ACTION = "SET_SELECTED_MODELER_ACTION";
export const FETCH_MODELERS_BEGIN_ACTION = "FETCH_MODELERS_BEGIN_ACTION";
export const FETCH_MODELERS_FAILURE_ACTION = "FETCH_MODELERS_FAILURE_ACTION";
export const FETCH_MODELERS_SUCCESS_ACTION = "FETCH_MODELERS_SUCCESS_ACTION";
export const FETCH_MODELER_BY_ID_BEGIN_ACTION = "FETCH_MODELER_BY_ID_BEGIN_ACTION";
export const FETCH_MODELER_BY_ID_FAILURE_ACTION = "FETCH_MODELER_BY_ID_FAILURE_ACTION";
export const FETCH_MODELER_BY_ID_SUCCESS_ACTION = "FETCH_MODELER_BY_ID_SUCCESS_ACTION";
export const CREATE_UPDATE_MODELER_BEGIN_ACTION = "CREATE_UPDATE_MODELER_BEGIN_ACTION";
export const CREATE_UPDATE_MODELER_SUCCESS_ACTION = "CREATE_UPDATE_MODELER_SUCCESS_ACTION";
export const DELETE_MODELER_BEGIN_ACTION = "DELETE_MODELER_BEGIN_ACTION";
export const DELETE_MODELER_SUCCESS_ACTION = "DELETE_MODELER_SUCCESS_ACTION";
export const DELETE_MODELER_FAILURE_ACTION = "DELETE_MODELER_FAILURE_ACTION";
export const CLONE_MODELER_BEGIN_ACTION = "CLONE_MODELER_BEGIN_ACTION";
export const CLONE_MODELER_SUCCESS_ACTION = "CLONE_MODELER_SUCCESS_ACTION";
export const CLONE_MODELER_FAILURE_ACTION = "CLONE_MODELER_FAILURE_ACTION";
export const RESET_ERRORS_ACTION = "RESET_ERRORS_ACTION";
export const UPDATE_MODELER_THUMBNAIL_IMAGE_ACTION = "UPDATE_MODELER_THUMBNAIL_IMAGE_ACTION";
export const UPDATE_MODELER_BEGING_ACTION = "UPDATE_MODELER_BEGING_ACTION";
export const UPDATE_MODELER_SUCCESS_ACTION = "UPDATE_MODELER_SUCCESS_ACTION";
export const UPDATE_MODELER_FAILURE_ACTION = "UPDATE_MODELER_FAILURE_ACTION";
export const resetErrors = () => {
  return {
    type: RESET_ERRORS_ACTION,
    payload: undefined
  }
}
export const updateModelerThumbnailImage = (image) => {
  return {
    type: UPDATE_MODELER_THUMBNAIL_IMAGE_ACTION,
    payload: image
  }
}
export const updateModelerBegin = () => {
  return {
    type: UPDATE_MODELER_BEGING_ACTION,
    payload: undefined
  }
}
export const updateModelerSuccess = () => {
  return {
    type: UPDATE_MODELER_SUCCESS_ACTION,
    payload: undefined
  }
}
export const updateModelerFailure = (message) => {
  return {
    type: UPDATE_MODELER_FAILURE_ACTION,
    payload: message
  }
}

export const cloneModelerBegin = (modeler) =>{
  return {
    type: CLONE_MODELER_BEGIN_ACTION,
    payload: modeler
  }
}

export const cloneModelerSuccess = (modeler) =>{
  return {
    type: CLONE_MODELER_SUCCESS_ACTION,
    payload: modeler
  }
}

export const cloneModelerFailure = (message) =>{
  return {
    type: CLONE_MODELER_FAILURE_ACTION,
    payload: message
  }
}

export const setactiveModeler = (modeler) =>{
  return {
    type: SET_SELECTED_MODELER_ACTION,
    payload: modeler
  }
}
export const createUpdateModelerBegin = () =>{
  return {
    type: CREATE_UPDATE_MODELER_BEGIN_ACTION,
    payload: undefined
  }
}

export const createUpdateModelerSuccess = () =>{
  return {
    type: CREATE_UPDATE_MODELER_SUCCESS_ACTION,
    payload: undefined
  }
}

export const deleteModelerBegin = () =>{
  return {
    type: DELETE_MODELER_BEGIN_ACTION ,
    payload: undefined
  }
}

export const deleteModelerSuccess = () =>{
  return {
    type: DELETE_MODELER_SUCCESS_ACTION,
    payload: undefined
  }
}
export const deleteModelerFailure = (message) =>{
  return {
    type: DELETE_MODELER_FAILURE_ACTION,
    payload: message
  }
}

export const fetchModelersBegin = () => {
  return {
    type: FETCH_MODELERS_BEGIN_ACTION,
    payload: undefined,
  };
};
export const fetchModelersSuccess = (res) => {
  return {
    type: FETCH_MODELERS_SUCCESS_ACTION,
    payload: res,
  };
};

export const fetchModelersFailure = (message) => {
  return {
    type: FETCH_MODELERS_FAILURE_ACTION,
    payload: message,
  };
};

export const fetchModelerByIdBegin = (id) => {
  return {
    type: FETCH_MODELER_BY_ID_BEGIN_ACTION,
    payload: id,
  };
};
export const fetchModelerByIdSuccess = (res) => {
  return {
    type: FETCH_MODELER_BY_ID_SUCCESS_ACTION,
    payload: res,
  };
};

export const fetchModelerByIdFailure = (message) => {
  return {
    type: FETCH_MODELER_BY_ID_FAILURE_ACTION,
    payload: message,
  };
};

// New actions for publishing modeler reports
export const PUBLISH_MODELER_REPORT_BEGIN_ACTION = "PUBLISH_MODELER_REPORT_BEGIN_ACTION";
export const PUBLISH_MODELER_REPORT_SUCCESS_ACTION = "PUBLISH_MODELER_REPORT_SUCCESS_ACTION";
export const PUBLISH_MODELER_REPORT_FAILURE_ACTION = "PUBLISH_MODELER_REPORT_FAILURE_ACTION";

export const publishModelerReportBegin = () => {
  return {
    type: PUBLISH_MODELER_REPORT_BEGIN_ACTION,
    payload: undefined,
  };
};

export const publishModelerReportSuccess = (result) => {
  return {
    type: PUBLISH_MODELER_REPORT_SUCCESS_ACTION,
    payload: result,
  };
};

export const publishModelerReportFailure = (message) => {
  return {
    type: PUBLISH_MODELER_REPORT_FAILURE_ACTION,
    payload: message,
  };
};
